import React from "react";
import { QuoteStatus } from "../../../utils/Quote/Quote";
import style from "../Quotebar.module.scss";

export const Status = (props) => {
  const { quote } = props;
  const { expired } = quote;

  switch (quote.AdvisorQuoteStatus) {
    case QuoteStatus.WAITING:
      return null;
    case QuoteStatus.PRICED:
      if (expired) {
        return (
          <div className="small">
            <span style={{ color: "#ed5565" }} className={style.status}>
              {"Expired"}
            </span>
          </div>
        );
      }

      return (
        <div className="small">
          <span style={{ color: "#2cb15a" }} className={style.status}>
            {"Priced"}
          </span>
        </div>
      );
    case QuoteStatus.USED:
      return (
        <div className="small">
          <span style={{ color: "#607d8b" }} className={style.status}>
            {"Used"}
          </span>
        </div>
      );
    case QuoteStatus.REJECTED_BY_RECEIVER:
    case QuoteStatus.REJECTED_BY_SENDER:
      return (
        <div className="small">
          <span style={{ color: "#ed5565" }} className={style.status}>
            Rejected
          </span>{" "}
          <span>({quote.AdvisorQuoteRejectReason})</span>
        </div>
      );
  }
};
